var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"dialog"},[_c('LoadingIcon')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }